export default "__VITE_ASSET__DsYyc2GZ__"